import styled from "@emotion/native"
import AutoPayIcon from "../../../assets/Autopay.svg"
import { ActivityIndicator, Switch } from "react-native"
import WithdrawalLimitIcon from "../../../assets/withdrawal-limit.svg"
import { AutoPayListItem } from "./AutoPayListItem"
import { Text } from "../../../ui-components"
import { useCurrencyFormatter } from "../../../hooks"
import { useTheme } from "@emotion/react"

type AutoPayFirstStepProps = {
  isAutoPayEnabled: boolean
  setIsAutoPayEnabled: (isAutoPayEnabled: boolean) => void
  withdrawalLimit: number | undefined | null
  onPressWithdrawalLimit: () => void
  isPendingAutoPay: boolean
}

export function AutoPayFirstStep({
  isAutoPayEnabled,
  setIsAutoPayEnabled,
  withdrawalLimit,
  onPressWithdrawalLimit,
  isPendingAutoPay,
}: AutoPayFirstStepProps) {
  const { formatAmount } = useCurrencyFormatter()
  const theme = useTheme()

  return (
    <Container>
      <AutoPayListItem
        leftIcon={<AutoPayIcon color={theme.autoPay.modalIconColor} />}
        label="Activate auto pay"
        rightElement={
          isPendingAutoPay ? (
            <ActivityIndicator size="small" />
          ) : (
            <Switch
              trackColor={{ false: "#000000", true: "#000000" }}
              thumbColor={isAutoPayEnabled ? "#FFFFFF" : "#FFFFFF"}
              onValueChange={setIsAutoPayEnabled}
              value={isAutoPayEnabled}
              style={{ alignSelf: "flex-end" }}
            />
          )
        }
      />
      {isAutoPayEnabled && (
        <AutoPayListItem
          onPress={onPressWithdrawalLimit}
          leftIcon={<WithdrawalLimitIcon />}
          label="Set withdrawal limit"
          rightElement={
            withdrawalLimit ? (
              <Text fontSize={18} lineHeight={26} fontFamily="IBMPlexSans-Medium">
                {formatAmount({ value: withdrawalLimit, currencyCode: "USD" })}
              </Text>
            ) : undefined
          }
        />
      )}
    </Container>
  )
}

const Container = styled.View`
  gap: 12px;
  padding-bottom: 60px;
`
